import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import FaqSection from '../../components/FaqSection/FaqSection.js';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from "../../images/logo.png";


const ProjectPage = () => {
    return (
      <Fragment>
        <Navbar hclass={"wpo-site-header wpo-site-header-s2"} Logo={Logo} />
        <PageTitle pageTitle={"Preguntas frecuentes"} pagesub={"Faq"} />
        <FaqSection />
        <Footer hclass={"wpo-site-footer_s2"} />
        <Scrollbar />
      </Fragment>
    );
};
export default ProjectPage;





